import { FireFilled, RightOutlined } from '@ant-design/icons'
import { Button, Flex, Tag } from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import './fastLaneCard.scss'

const FastLaneCard = ({
  onClickDetail = () => {},
  onClickSwitchComplete = () => {},
  workId = null,
  title = 'Fast',
  dueDateTime = '21:23', // 2026-01-20 21:23:00
  isComplete = false,
  setIsModalOpen = () => {},
}) => {
  const completeColor = isComplete ? '#ADADAD' : '#383E44'
  const labelColor = isComplete ? '#6D747A' : '#191A1C'
  const isIssue =
    !isComplete && dueDateTime < dayjs().format('YYYY-MM-DD HH:mm:ss')
  return (
    <div className="fast-lane-card" onClick={() => onClickDetail(workId)}>
      <div
        className="fast-lane-card-label"
        style={{ backgroundColor: completeColor }}
      />
      <Flex
        justify="space-between"
        align="center"
        className="fast-lane-card-header"
        // onClick={() => onClickDetail(workId)}
      >
        <Flex align="center" gap={8}>
          <p className="fast-lane-card-title" style={{ color: completeColor }}>
            {'Fast'}
          </p>
          {isIssue && (
            <Tag
              icon={<FireFilled style={{ color: '#F25A67' }} />}
              style={{
                borderRadius: '6px',
                fontSize: '10px',
                margin: 0,
                background: '#fff',
                color: '#F25A67',
                border: '1px solid #F25A67',
                fontWeight: '700',
                padding: '0 6px',
              }}
            ></Tag>
          )}
        </Flex>
        <RightOutlined className="fast-lane-card-arrow" />
      </Flex>

      <Flex vertical gap={8} className="fast-lane-card-body">
        <p className="fast-lane-card-task" style={{ color: labelColor }}>
          {title || '--'}
        </p>
        <Button
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClickSwitchComplete(workId, isComplete)
          }}
          className={`fast-lane-card-status-btn ${isComplete ? 'done' : ''}`}
        >
          {isComplete ? (
            <img
              src="/assets/icon/aops/check-gray-icon.svg"
              alt="check"
              style={{ width: '12px', height: '12px' }}
              // className="check-green-icon"
            />
          ) : null}
          <span>{isComplete ? '완료됨' : '완료'}</span>
        </Button>
      </Flex>
    </div>
  )
}

export default FastLaneCard
